const e = "";
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/float-window/floatWindowContent.vue3.js
// module id = 1293
// module chunks = 67